import React from 'react';
import styled, {css} from 'styled-components';
import presets from "../utils/presets";
import {rhythm} from "../utils/typography";

const Content = styled.div`
  height:100%;
  width:100%;
  position:relative;
  padding:${rhythm(2)} ${rhythm(1)};
  display:flex;
  align-items: center;

  ${props => props.end && css`
    align-items: flex-end;
  `}

  ${props => props.start && css`
    align-items: flex-start;
  `}

  @media ${presets.mobile.lan}{
    width:100%;
  }

  @media screen and ${presets.tablet.lan}{
    width:75%;
  }

  @media screen and ${presets.desktop.lan}{
    width:calc(100%/2);
  }

  @media screen and ${presets.desktop.por}{
    width:calc(100%/2);
  }

  @media screen and ${presets.vhd.lan}{
    width:calc(100%/3);
  }

  @media screen and ${presets.vvhd.lan}{
    width:calc(100%/4);
  }
`

export default (props) => {
  return(
    <Content {...props}><div>{props.children}</div></Content>
  );
}



// WEBPACK FOOTER //
// ./src/com/Content.js